export function slugify(input, fallback = 'item') {
  const s = String(input ?? '')
    .normalize('NFKD')
    .replace(/[̀-ͯ]/g, '')
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-+|-+$/g, '')
    .slice(0, 80);
  return s || fallback;
}

export function safeFilename(name, fallback = 'file') {
  const cleaned = String(name ?? '')
    .replace(/[\/\\:*?"<>|\x00-\x1f]/g, '_')
    .replace(/^\.+/, '')
    .trim();
  return cleaned || fallback;
}

export function shortId(id, len = 8) {
  const s = String(id ?? '');
  return s.slice(-len).replace(/[^a-z0-9]/gi, '');
}
